import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function FooterSupport() {
  return <footer className="max-w-lg mx-auto px-4 pb-8" data-id="element-12">
      <div className="text-center space-y-4" data-id="element-13">
        {/* Support Section */}
        <div className="flex items-center justify-center gap-2 text-sm text-deep-cocoa/80" data-id="element-14">
          <MessageCircleIcon className="w-4 h-4 text-champagne-gold" data-id="element-15" />
          <span data-id="element-16">¿Necesitas ayuda?</span>
          <a href="https://wa.me/525512345678" className="font-medium text-champagne-gold hover:text-champagne-gold/80 transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-17">
            Escríbenos por WhatsApp
          </a>
        </div>

        {/* Legal Links */}
        <div className="flex items-center justify-center gap-3 text-xs text-deep-cocoa/60" data-id="element-18">
          <a href="/privacidad" className="hover:text-deep-cocoa transition-colors" data-id="element-19">
            Políticas de privacidad
          </a>
          <span data-id="element-20">•</span>
          <a href="/terminos" className="hover:text-deep-cocoa transition-colors" data-id="element-21">
            Términos y condiciones
          </a>
          <span data-id="element-22">•</span>
          <a href="/garantia" className="hover:text-deep-cocoa transition-colors" data-id="element-23">
            Garantía
          </a>
        </div>

        {/* Copyright */}
        <p className="text-xs text-deep-cocoa/50" data-id="element-24">
          © 2024 Gana500TikTokShop. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}